import { InjectionToken } from '@angular/core'
import { EnvironmentName } from 'shared-services'

export const environmentNameToken = new InjectionToken<EnvironmentName>(
  'EnvironmentNameToken',
)
